import customQueryStringify from "../../helpers/queryString";
import http from "../../services/api";
import store from "../index";
import * as types from "./../types/categorias";

export function loadCategorias(query) {
  const qrt = customQueryStringify(query);

  return new Promise((resolve, reject) => {
    store.dispatch({ type: types.CATEGORIAS_LOADING, payload: true });
    http.get(`/api/v1/adm/categorias/listar?${qrt}`).then(
      (response) => {
        store.dispatch([
          { type: types.CATEGORIAS_DATA, payload: response.data.categorias },
          { type: types.CATEGORIAS_DATA_PAGE, payload: response.data.page },
          { type: types.CATEGORIAS_DATA_PER_PAGE, payload: response.data.per_page },
          { type: types.CATEGORIAS_DATA_TOTAL, payload: response.data.total },
          { type: types.CATEGORIAS_LOADING, payload: false },
        ]);
        resolve(response.data);
      },
      (e) => {
        store.dispatch({ type: types.CATEGORIAS_LOADING, payload: false });
        reject(e);
      }
    );
  });
}

export function ActionCadatrarCategoriaWl(data) {
  return new Promise((resolve, reject) => {
    store.dispatch({ type: types.CATEGORIAS_LOADING, payload: true });
    http.post(`/api/v1/adm/categorias/cadastro`, data).then(
      (response) => {
        store.dispatch([{ type: types.CATEGORIAS_LOADING, payload: false }]);
        resolve(response.data);
      },
      (e) => {
        store.dispatch({ type: types.CATEGORIAS_LOADING, payload: false });
        reject(e);
      }
    );
  });
}

export function ActionAtualizarCategoria(data) {
  return new Promise((resolve, reject) => {
    store.dispatch({ type: types.CATEGORIAS_LOADING, payload: true });
    http.put(`/api/v1/adm/categorias/atualizar`, data).then(
      (response) => {
        store.dispatch([{ type: types.CATEGORIAS_LOADING, payload: false }]);
        resolve(response.data);
      },
      (e) => {
        store.dispatch({ type: types.CATEGORIAS_LOADING, payload: false });
        reject(e);
      }
    );
  });
}

export function ListarCategoriasDisponiveisParaParceiro(query) {
  const qrt = customQueryStringify(query);
  return new Promise((resolve, reject) => {
    store.dispatch({ type: types.CATEGORIAS_LOADING, payload: true });
    http.get(`/api/v1/adm/categorias/listar-parceiro?${qrt}`).then(
      (response) => {
        store.dispatch([{ type: types.CATEGORIAS_LOADING, payload: false }]);
        store.dispatch([{ type: types.CATEGORIAS_DISPONIVEIS_PARCEIRO, payload: response.data }]);
        resolve(response.data);
      },
      (e) => {
        store.dispatch({ type: types.CATEGORIAS_LOADING, payload: false });
        reject(e);
      }
    );
  });
}
